// extracted by mini-css-extract-plugin
export default {"controlPanel":"ControlPanel_controlPanel__ntvRw"};